// extracted by mini-css-extract-plugin
export default {"item":"ProductItemBase-item_iDUMX","child":"ProductItemBase-child_lg2aV"};